import * as variables from './variables.js';

import 'window.requestanimationframe';

import { Analytics } from '@plaudit/analytics';
Analytics.setup();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;


import Forms from './component/Forms';
Forms.init();

import MainMenu from './component/MainMenu';
new MainMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTarget_slidable : '.childWrap--L2',
	nodeTrigger 	: '.node--hasChild > a',
	headTarget 		: '.childWrap__heading',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	//hideSiblingMenuItems: selectorMatchesConferenceNodes,
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 		: 'hasMenuSetup',
		menuOpen 	: 'hasMenuOpen',
		nodeOpen 	: 'isOpen',
		backWrap 	: 'childWrap__back'
	}
});

import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup();

import featureCarousel from './component/FeatureCarousel';
const entryCarouselEl = document.querySelector('.__entry .featureCarousel') as HTMLElement;
if (entryCarouselEl) {
	const entryCarousel = new featureCarousel({
		analyticsCategory: 'Feature Carousel',
		carouselClass: 'featureCarousel',
		carouselEl: entryCarouselEl,
		duration: 7500,
		doIndicatorClick: true,
	});
}

import VideoLightbox from './component/VideoLightbox';
VideoLightbox();

import Gallery from './component/Gallery';
new Gallery();

import InteractiveGraphic from './component/InteractiveGraphic';
new InteractiveGraphic();

import InternetPlans from './component/InternetPlans';
new InternetPlans();

import premierhqCarousel from './component/premierhqCarousel';
premierhqCarousel();
